<script>
	const _ = require('underscore');
	const i18n = require('i18n/i18n');

	function getOptions(code) {
		if (!code) return null;

		const options = [i18n.getLanguageSet(i18n.defaultLanguage), i18n.getLanguageSet(code)];

		return options.map(l =>
			_.assign(
				{},
				{
					text: l.endonym,
					value: l.languageCode,
					selected: l.languageCode === i18n.defaultLanguage,
					rtl: l.rtl
				}
			)
		);
	}

	module.exports = {
		props: {
			setLanguage: {
				type: Function,
				required: true,
				default: function () {}
			},
			studentLanguage: {
				type: String,
				required: true,
				default: 'es'
			}
		},
		data() {
			const options = getOptions(this.studentLanguage);
			return {
				options
			};
		},
		methods: {
			onLanguageClick: function (code) {
				this.options.forEach(opt => {
					opt.selected = opt.value === code;
				});

				this.setLanguage(code);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/global';

	.language-toggle {
		.language-option {
			&:focus-within .option-text {
				@include focus-outline;
			}
		}

		.option-text:not(.language-selected) {
			color: $c-blue;
			cursor: pointer;
		}
	}
</style>
<template>
	<fieldset class="language-toggle font-small">
		<legend class="hidden-visually">Select language</legend>
		<label
			v-for="(opt, index) in options"
			:key="opt.value"
			:class="{
				'language-option': true,
				'ell-rtl': opt.rtl
			}">
			<input
				type="radio"
				class="hidden-visually"
				:value="opt.value"
				:checked="opt.selected"
				@change="onLanguageClick(opt.value)"
				name="language-toggle" />
			<span
				class="option-text"
				:class="{
					'language-selected': opt.selected
				}"
				>{{ opt.text }}</span
			>
			<span v-if="index !== options.length - 1"> | </span>
		</label>
	</fieldset>
</template>
